import { render, staticRenderFns } from "./BenefitCodeStats.vue?vue&type=template&id=3512a6db&"
import script from "./BenefitCodeStats.vue?vue&type=script&lang=js&"
export * from "./BenefitCodeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports